module.exports = __webpack_public_path__ + "img/meal-icon-snack.fb8ca7d9.svg";